<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Hak Akses</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link href="/admin/roles">Hak Akses</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <ul class="nav nav-tabs mb-3">
                <li class="nav-item"> 
                  <a class="nav-link cp" :class="{ 'active': tab == 'profil' }" @click="tab = 'profil'">Profil</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link cp" :class="{ 'active': tab == 'akun' }" @click="tab = 'akun'">Pengaturan Akun</a>
                </li>
              </ul>


              <div v-if="tab == 'akun'" class="row">
                <div class="col-md-6">
                  <h5 class="mb-3 pb-2 border-bottom">Pengaturan Akun</h5>
                  <form @submit.prevent="action" method="post">  
                    <div class="mb-3">
                      <label for="username" class="form-label">Username</label>
                      <input type="text" v-model="form.username" class="form-control" id="username" readonly>
                    </div>
                    <div class="mb-3">
                      <label for="nama_lengkap" class="form-label">Nama Akun</label>
                      <input type="text" v-model="form.nama_lengkap" class="form-control" id="nama_lengkap">
                    </div>
                    <div class="mb-3">
                      <label for="email" class="form-label">Email</label>
                      <input type="email" v-model="form.email" class="form-control" id="email">
                    </div>
                    <button type="submit" class="btn btn-primary">Simpan Perubahan</button>
                  </form>
                </div>

                <div class="col-md-6">
                  <h5 class="mb-3 pb-2 border-bottom">Password</h5>
                  <form @submit.prevent="resetPassword" method="post">
                  <div class="mb-3">
                    <label for="password" class="form-label">Password Baru</label>
                    <input type="password" v-model="form.password" class="form-control" id="password">
                  </div>
                  <div class="mb-3">
                    <label for="password" class="form-label">Konfirmasi Password Baru</label>
                    <input type="password" v-model="form.password_confirm" class="form-control" id="password">
                  </div>
                  <button class="btn btn-danger">Reset Password</button>
                  </form>
                </div>
              </div>

              <div v-if="tab == 'profil'">
                <Profile :master="{}" :readonly="true" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>

</template>

<script>
import Layout from '@/layout/Index'
import Modal from '@/components/Modal'
import Profile from '@/components/Profile'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'

export default {
  layout: Layout,
  components: { Profile },
  props: {
    user: Object,
    jenis: String
  },
  data() {
    return {
      tab: 'akun',
      form: {
        id: null,
        nama_lengkap: '',
        username: '',
        email: '',

        password: '',
        password_confirm: ''
      },
    }
  },
  methods: {
    action() {
      this.$inertia.post('/admin/profile/akun', this.form);
    },
    resetPassword() {
      if(this.form.password_confirm == this.form.password && this.form.password) {
        this.$inertia.post('/admin/profile/password', this.form);
      } else {
        alert('Konfirmasi Password tidak sama!');
      }
    },
  },
  mounted() {
    this.form.nama_lengkap = this.user.nama_lengkap;
    this.form.username = this.user.username;
    this.form.email = this.user.email;
    this.form.id = this.user.id;
    this.tab = this.jenis;
  }
}
</script>
